import { Helpers } from '../../helpers';
import { IFracFleet } from '../../interfaces/ifrac-fleet';
import { FracFleet } from '../frac-fleet';
import { FracFleetAvailability } from '../frac-fleet-availability';
import { ProjectCompletionsParameter } from '../project-completions-parameter';
import { Scenario } from '../scenario';
import { ScheduleActivity } from '../schedule-activity';

export class FracFleetBase {
  FracFleetId: number;
  ScenarioId: number | null;
  ParentFracFleetId: number | null;
  Name: string;
  MaxWellAllowance: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;
  SysStartTime: Date;
  SysEndTime: Date;

  FracFleetAvailabilities_FracFleet?: Array<FracFleetAvailability> | null;
  ProjectCompletionsParameters_FracFleet?: Array<ProjectCompletionsParameter> | null;
  ScheduleActivities_FracFleet?: Array<ScheduleActivity> | null;
  FracFleets_ParentFracFleet?: Array<FracFleet> | null;
  Scenario?: Scenario;
  ParentFracFleet?: FracFleet;

  constructor(item?: IFracFleet) {
    if (item) {

      this.FracFleetId = item.FracFleetId;
      this.ScenarioId = item.ScenarioId;
      this.ParentFracFleetId = item.ParentFracFleetId;
      this.Name = item.Name;
      this.MaxWellAllowance = item.MaxWellAllowance;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;
      this.SysStartTime = item.SysStartTime ? new Date(item.SysStartTime) : null;
      this.SysEndTime = item.SysEndTime ? new Date(item.SysEndTime) : null;

      this.FracFleetAvailabilities_FracFleet = Helpers.createClassArray(FracFleetAvailability, item.FracFleetAvailabilities_FracFleet);
      this.ProjectCompletionsParameters_FracFleet = Helpers.createClassArray(ProjectCompletionsParameter, item.ProjectCompletionsParameters_FracFleet);
      this.ScheduleActivities_FracFleet = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_FracFleet);
      this.FracFleets_ParentFracFleet = Helpers.createClassArray(FracFleet, item.FracFleets_ParentFracFleet);
      this.Scenario = new Scenario(item.Scenario);
      this.ParentFracFleet = new FracFleet(item.ParentFracFleet);
    }
  }
}